export const normalizeQuestionSectionId = (question) => {
  const sectionId =
    question?.section ??
    question?.section_id ??
    question?.sectionId ??
    null;

  if (sectionId === null || sectionId === undefined || sectionId === "") {
    return null;
  }

  if (typeof sectionId === "object" && sectionId !== null) {
    const objVal = sectionId.id ?? sectionId.pk ?? sectionId.client_id;
    if (objVal !== null && objVal !== undefined && objVal !== "") {
      return String(objVal);
    }
  }

  return String(sectionId);
};

export const getQuestionSortOrder = (question, fallbackIndex = 0) => {
  const sortOrder =
    question?.sort_order ??
    question?.order ??
    question?.sequence ??
    fallbackIndex + 1;

  return Number(sortOrder) || fallbackIndex + 1;
};

export const buildChecklistSections = ({
  sections = [],
  questions = [],
  includeUnsectioned = true,
}) => {
  const activeSections = (Array.isArray(sections) ? sections : [])
    .filter((section) => section?.is_active !== false)
    .sort(
      (a, b) =>
        Number(a?.sort_order || 0) - Number(b?.sort_order || 0) ||
        String(a?.title || "").localeCompare(String(b?.title || ""))
    );

  const sortedQuestions = (Array.isArray(questions) ? questions : [])
    .filter((question) => question?.is_active !== false)
    .sort(
      (a, b) =>
        getQuestionSortOrder(a) - getQuestionSortOrder(b) ||
        Number(a?.id || 0) - Number(b?.id || 0)
    );

  const groups = activeSections.map((section) => ({
    id: String(section.id),
    client_id: section.client_id ? String(section.client_id) : null,
    title: section.title || section.name || `Section ${section.id}`,
    description: section.description || "",
    sort_order: section.sort_order || 0,
    questions: [],
  }));

  const sectionMap = new Map();
  groups.forEach((group, index) => {
    const rawSection = activeSections[index];
    if (group.id) sectionMap.set(group.id, group);
    if (group.client_id) sectionMap.set(group.client_id, group);
    if (group.id) sectionMap.set(`existing_section_${group.id}`, group);
    if (rawSection?.id) sectionMap.set(String(rawSection.id), group);
  });

  const unsectioned = {
    id: "__general__",
    title: "General",
    description: "",
    sort_order: 999999,
    questions: [],
  };

  sortedQuestions.forEach((question) => {
    const sectionId = normalizeQuestionSectionId(question);

    if (sectionId && sectionMap.has(sectionId)) {
      sectionMap.get(sectionId).questions.push(question);
    } else if (includeUnsectioned) {
      unsectioned.questions.push(question);
    }
  });

  const finalGroups = groups.filter((section) => section.questions.length > 0);

  if (unsectioned.questions.length > 0) {
    finalGroups.push(unsectioned);
  }

  return finalGroups;
};

export const hasChecklistSections = (sections = [], questions = []) => {
  return buildChecklistSections({ sections, questions }).length > 1;
};
